"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateReturnOrderSalesforceSchema = void 0;
exports.CreateReturnOrderSalesforceSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        sonosId: {
            type: 'string',
            minLength: 1,
        },
        serialNumber: {
            type: 'string',
            minLength: 1,
        },
        reasonForReturn: {
            type: 'string',
        },
        repaymentMethod: {
            type: 'string',
        },
        refundEvent: {
            type: 'string',
        },
        assumedDefect: {
            type: 'string',
        },
        handlingClass: {
            type: 'string',
        },
        quantityExpected: {
            type: 'number',
        },
        quantityReturned: {
            type: 'number',
        },
    },
    required: ['sonosId', 'serialNumber'],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlLXJldHVybi1vcmRlci1zYWxlc2ZvcmNlLXNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9kb21zL3NjaGVtYXMvc2FsZXNmb3JjZS9jcmVhdGUtcmV0dXJuLW9yZGVyLXNhbGVzZm9yY2Utc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsaUNBQWlDLEdBQUc7SUFDL0MsT0FBTyxFQUFFLHlDQUF5QztJQUNsRCxVQUFVLEVBQUU7UUFDVixPQUFPLEVBQUU7WUFDUCxJQUFJLEVBQUUsUUFBUTtZQUNkLFNBQVMsRUFBRSxDQUFDO1NBQ2I7UUFDRCxZQUFZLEVBQUU7WUFDWixJQUFJLEVBQUUsUUFBUTtZQUNkLFNBQVMsRUFBRSxDQUFDO1NBQ2I7UUFDRCxlQUFlLEVBQUU7WUFDZixJQUFJLEVBQUUsUUFBUTtTQUNmO1FBQ0QsZUFBZSxFQUFFO1lBQ2YsSUFBSSxFQUFFLFFBQVE7U0FDZjtRQUNELFdBQVcsRUFBRTtZQUNYLElBQUksRUFBRSxRQUFRO1NBQ2Y7UUFDRCxhQUFhLEVBQUU7WUFDYixJQUFJLEVBQUUsUUFBUTtTQUNmO1FBQ0QsYUFBYSxFQUFFO1lBQ2IsSUFBSSxFQUFFLFFBQVE7U0FDZjtRQUNELGdCQUFnQixFQUFFO1lBQ2hCLElBQUksRUFBRSxRQUFRO1NBQ2Y7UUFDRCxnQkFBZ0IsRUFBRTtZQUNoQixJQUFJLEVBQUUsUUFBUTtTQUNmO0tBQ0Y7SUFDRCxRQUFRLEVBQUUsQ0FBQyxTQUFTLEVBQUUsY0FBYyxDQUFDO0lBQ3JDLElBQUksRUFBRSxRQUFRO0NBQ2YsQ0FBQSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBDcmVhdGVSZXR1cm5PcmRlclNhbGVzZm9yY2VTY2hlbWEgPSB7XG4gICRzY2hlbWE6ICdodHRwOi8vanNvbi1zY2hlbWEub3JnL2RyYWZ0LTA3L3NjaGVtYSMnLFxuICBwcm9wZXJ0aWVzOiB7XG4gICAgc29ub3NJZDoge1xuICAgICAgdHlwZTogJ3N0cmluZycsXG4gICAgICBtaW5MZW5ndGg6IDEsXG4gICAgfSxcbiAgICBzZXJpYWxOdW1iZXI6IHtcbiAgICAgIHR5cGU6ICdzdHJpbmcnLFxuICAgICAgbWluTGVuZ3RoOiAxLFxuICAgIH0sXG4gICAgcmVhc29uRm9yUmV0dXJuOiB7XG4gICAgICB0eXBlOiAnc3RyaW5nJyxcbiAgICB9LFxuICAgIHJlcGF5bWVudE1ldGhvZDoge1xuICAgICAgdHlwZTogJ3N0cmluZycsXG4gICAgfSxcbiAgICByZWZ1bmRFdmVudDoge1xuICAgICAgdHlwZTogJ3N0cmluZycsXG4gICAgfSxcbiAgICBhc3N1bWVkRGVmZWN0OiB7XG4gICAgICB0eXBlOiAnc3RyaW5nJyxcbiAgICB9LFxuICAgIGhhbmRsaW5nQ2xhc3M6IHtcbiAgICAgIHR5cGU6ICdzdHJpbmcnLFxuICAgIH0sXG4gICAgcXVhbnRpdHlFeHBlY3RlZDoge1xuICAgICAgdHlwZTogJ251bWJlcicsXG4gICAgfSxcbiAgICBxdWFudGl0eVJldHVybmVkOiB7XG4gICAgICB0eXBlOiAnbnVtYmVyJyxcbiAgICB9LFxuICB9LFxuICByZXF1aXJlZDogWydzb25vc0lkJywgJ3NlcmlhbE51bWJlciddLFxuICB0eXBlOiAnb2JqZWN0Jyxcbn1cbiJdfQ==